import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Context from '../../containers/App/MainProvider/context';

export default function useUploadFiles(): [
  FormData | null,
  Dispatch<SetStateAction<FormData | null>>,
  (e: React.ChangeEvent<HTMLInputElement>) => void,
  (index: string) => void
] {
  const { notify } = useContext(Context);
  const [formData, setFormData] = useState<FormData | null>(null);
  const MaxSize = 30 * 1024 * 1024;

  const { t } = useTranslation();

  const selectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (!files) {
      return;
    }

    let oversizeFile = false;

    Array.from(files).forEach((ele) => {
      if (ele.size > MaxSize) {
        oversizeFile = true;
        notify('Documents', t('uploadMaxSizeError30'), 'danger', 'exclamation-triangle');
      }
    });

    const dataForm = new FormData();
    const formDataNames = formData
      ? Array.from(formData.entries()).map((x) => {
          dataForm.append(x[0], x[1]);
          const file = x[1] as File;
          return file.name;
        })
      : [];

    const duplicateds = formDataNames.filter((value) =>
      Array.from(files)
        .map((x) => x.name)
        .includes(value)
    );

    if (duplicateds.some((x) => x)) {
      notify(
        'Documents',
        'You have selected a file that has already been added',
        'danger',
        'exclamation-triangle'
      );
    } else if (!oversizeFile) {
      Array.from(files).forEach((file, i) => {
        if (!formDataNames.includes(file.name)) {
          dataForm.append(`files`, files[i]);
        }
      });
      setFormData(dataForm);
    }
    e.target.value = '';
  };
  const deleteDoc = (docName: string) => {
    if (formData) {
      const dataForm = new FormData();
      Array.from(formData.entries()).forEach((x) => {
        const file = x[1] as File;
        if (docName !== file.name) {
          dataForm.append(x[0], x[1]);
        }
      });
      setFormData(dataForm);
    }
  };

  return [formData, setFormData, selectionChange, deleteDoc];
}
